export const TodayFinance = () => import("./TodayFinance");
export const IpdToday = () => import("./IpdToday");
export const OpdToday = () => import("./OpdToday");
export { default as MedicalCard } from "./MedicalCard";
export { default as IpdTable } from "./IpdTable";
export { default as OpdTable } from "./OpdTable";
export { default as POSOverview } from "./POSOverview";
export { default as TodayOverview } from "./TodayOverview";
